import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/overstockLocations'
import Component from 'components/OverstockLocations'

export default createListViewContainer({ actions, selectors: selectors.overstockLocations })(Component)
